import React, { useState, useEffect } from 'react';
import Nav from 'react-bootstrap/Nav';
import Tab from 'react-bootstrap/Tab';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import { useTranslation,Trans  } from 'react-i18next';

const Redevelopment = () => {
    const { t } = useTranslation();
    // State for active box per tab
    const [activeIndex, setActiveIndex] = useState({ first: 0, second: 0 });
    const [activeTab, setActiveTab] = useState('first'); // Track active tab

    // Handle hover on boxes
    const handleMouseEnter = (tabKey, index) => {
        setActiveIndex((prev) => ({ ...prev, [tabKey]: index }));
    };

    const boxesData = {
        first: [
            {
                title: t('boxesDataFirstTitle1'),
                description: t('boxesDataFirstDesc1'),
                imageSrc: "/images/home/redevelopment/icon/1/1.json"
            },
            {
                title: t('boxesDataFirstTitle2'),
                description: t('boxesDataFirstDesc2'),
                imageSrc: "/images/home/redevelopment/icon/1/2.json"
            },
            {
                title: t('boxesDataFirstTitle3'),
                description: t('boxesDataFirstDesc3'),
                imageSrc: "/images/home/redevelopment/icon/1/3.json"
            },
            {
                title: t('boxesDataFirstTitle4'),
                description: t('boxesDataFirstDesc4'),
                imageSrc: "/images/home/redevelopment/icon/1/4.json"
            }
        ],
        second: [
            {
                title: t('boxesDataSecondTitle1'),
                description: t('boxesDataSecondDesc1'),
                imageSrc: "/images/home/redevelopment/icon/2/1.json"
            },
            {
                title: t('boxesDataSecondTitle2'),
                description: t('boxesDataSecondDesc2'),
                imageSrc: "/images/home/redevelopment/icon/2/2.json"
            },
            {
                title: t('boxesDataSecondTitle3'),
                description: t('boxesDataSecondDesc3'),
                imageSrc: "/images/home/redevelopment/icon/2/3.json"
            },
            {
                title: t('boxesDataSecondTitle4'),
                description: t('boxesDataSecondDesc4'),
                imageSrc: "/images/home/redevelopment/icon/2/4.json"
            }
        ]
    };

    useEffect(() => {
        // Force Lottie to re-render when tab changes
        setTimeout(() => {
            window.dispatchEvent(new Event('resize'));
        }, 300);
    }, [activeTab]);

    return (
        <section className="lyt-section typ-redevelopment-section" id='lookfred'>
            <div className="container">
                <div className="heading-wrapper">
                    <div>
                        <h2 className="bs-heading typdblue mb-2" data-aos="fade-in" data-aos-delay="200">{t('RedevelopmentTitle')}</h2>
                        <p className="bs-para typgrey" data-aos="fade-in" data-aos-delay="300">
                         
                           <Trans i18nKey="bannerTitle" />
                        </p>
                    </div>
                </div>

                <div className="bs-tab">
                    <Tab.Container
                        id="left-tabs-example"
                        defaultActiveKey="first"
                        onSelect={(key) => setActiveTab(key)}
                    >
                        <Nav variant="pills" className="" data-aos="fade-in" data-aos-delay="200">
                            <Nav.Item>
                                <Nav.Link className="bs-btn" eventKey="first">{t('serviceBeneficiary')}</Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link className="bs-btn" eventKey="second">{t('serviceProvider')}</Nav.Link>
                            </Nav.Item>
                        </Nav>
                        <div className="row align-items-end" data-aos="fade-in" data-aos-delay="200">
                            <div className="col-lg-6 col-md-6 col-12 pe-lg-0 p-md-0">
                                <Tab.Content className="left-panel">
                                    {Object.keys(boxesData).map((tabKey) => (
                                        <Tab.Pane eventKey={tabKey} key={tabKey}>
                                            {boxesData[tabKey].map((box, index) => (
                                                <div
                                                    key={index}
                                                    className={`box ${activeIndex[tabKey] === index ? "active" : ""}`}
                                                    onMouseEnter={() => handleMouseEnter(tabKey, index)}
                                                >
                                                    <div className="box-img">
                                                        {activeTab === tabKey && (
                                                            <DotLottieReact
                                                                src={box.imageSrc}
                                                                loop
                                                                autoplay
                                                                className='img'
                                                                width={60}
                                                                height={60}
                                                            />
                                                        )}
                                                    </div>
                                                    <div className="box-content">
                                                        <div className="title" data-aos="fade-in" data-aos-delay="200">{box.title}</div>
                                                        <div className="description" data-aos="fade-in" data-aos-delay="300" dangerouslySetInnerHTML={{ __html: box.description }}></div>
                                                    </div>
                                                </div>
                                            ))}
                                        </Tab.Pane>
                                    ))}
                                </Tab.Content>
                            </div>
                            <div className="col-lg-6 col-md-6 col-12 ps-lg-0 ps-md-0">
                                <Tab.Content className="right-panel">
                                    <Tab.Pane eventKey="first">
                                        <img src="/images/home/redevelopment/1.jpg" alt="logo" width={612} height={681} />
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="second">
                                        <img src="/images/home/banner/banner.jpg" alt="logo" width={612} height={681} />
                                    </Tab.Pane>
                                </Tab.Content>
                            </div>
                        </div>
                    </Tab.Container>
                </div>
            </div>
        </section>
    );
};

export default Redevelopment;
